function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h2',[_vm._v("Phone call is the glue between anonymous web view and a sale.")]),_vm._v(" "),_c('p',[_vm._v("WhiteBox tracks calls from your website, and understands what the conversation was about. WhiteBox also reports automatically this information to Facebook and Google, so digital marketers could see the conversions in their analytics tools. Get information about:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("How many calls turned to customers?")]),_vm._v(" "),_c('li',[_vm._v("What is the conversation topic in the inbound calls?")]),_vm._v(" "),_c('li',[_vm._v("Is my back-office delivering the proper message?")])])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/interactions/call","interaction":"call","title":"(Call)|tracking","image":"/img/interactions/2.svg"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }